var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.btnPropsComputed,false),[_c('w-icon',{attrs:{"value":"ADD","left":_vm.isText}}),(_vm.isText)?_c('span',[_vm._v(_vm._s(_vm.prefixComputed)+" "+_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }